import React from 'react';

// Benchmark variant: iframes Mozilla's reference PDF.js viewer.
// Everyone agrees this feels silky; if our custom build doesn't match this, we're not done.
// Access via ?viewer=mozilla. Note that Mozilla's hosted viewer only accepts PDF URLs
// that send permissive CORS headers.

const PaperMozilla = ({ documentUrl }) => {
    const src = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(
        documentUrl
    )}`;
    return (
        <iframe
            src={src}
            title="PDF (Mozilla reference viewer)"
            style={{
                width: '100%',
                height: '100vh',
                border: 'none',
                display: 'block',
            }}
            allow="fullscreen"
        />
    );
};

export default PaperMozilla;
